
export const data = {
  
  en: {
    NominationPeriodClosure:{
      currentyear:"2022",
      nextyear:"2023",
      message:"The nomination period for 2022 has been closed. Thank you for recognizing all the extraordinary and dedicated caregivers and we will see you back here in 2023."
    },

    VIANominations: {
      welcome: "Welcome ",
      message:"The Values in Action Award is the highest honor we give at Providence. This annual recognition program celebrates caregivers who go above and beyond to model the five core values: Compassion, Dignity, Justice, Excellence and Integrity.",
        //"Values in Action allows all people of Providence St. Joseph Health to celebrate those who are embodying Compassion Dignity Justice Excellence and integrity. We honour those making deep commitments to our Mission and our vision of Health for a Better World.",
      findAndNominate: "Find and Nominate a caregiver",
      selectLabel: "Please enter LAST NAME, FIRST NAME",
      nominationsHeader:"NOMINATIONS",
      valuesInActionHeader:"ABOUT VALUES IN ACTION",
      systemAwardeesHeader:"SYSTEM AWARDEES",
      thoughtStartersPrompt: "Not sure where to start? Here are some",
      thoughtStartersLink: "Thought Starters",
    },

    searchBox:{
      selfNominationMsg:`You cannot nominate yourself. Please make another selection.`,
      duplicateNominationMsg:`You already submitted a nomination for this employee for this year. Please make another selection.`,
      error:`Error`,      
      userNotFound: `No user found. Try nominating manually here.`      
    },
    AdminSearchBox:
    {
      selfNominatingAdmin:'You are an Admin already. Please make another selection.',
      duplicateAdminMsg:'You already added this person as admin. Please make another selection',
      error:'Error',
      userNotFound:`No user found.`
    },

    errorMessage:{
      msg500: `Something went wrong, Please try back soon!`,
      msg400: `Bad Request. Please try again!`,
      msg404: `Resource not found`,
      msg401:`Unauthorized request, Please try again with authorized credentials!`,
      msg403:`Invalid Request`
    },

    nominationEditor:{
      intro: "Write Your Nomination",
      sampleWriteUp: "Not Sure where to start? Here are some ",
      writeUpLink: "Thought Starters",
      back:"BACK",
      textBoxPlaceHolder: "Write here...",
      of:"of",
      characters:"characters",
      minimum:"(500 minimum)",
      submitAnonymously: "Submit Anonymously",
      confirmationText: "Are you sure you want to submit this nomination anonymously? Values in Action nominations should be detailed and highlight real examples you have experienced of the nominee's great work. Submitting anonymously will reduce the personal insight in the nomination. Although the nominee will not be able to see your information, your name will be shared with our mission team who may follow up with you. ",
      yes:"YES",
      no:"NO",
      submit:"SUBMIT",
      draft:"SAVE AS DRAFT",
      saving: "Saving...",
      saved:"Saved as draft"
    },

    nominationSection:{
      title:"Nominations",
      draftTab:"Draft",
      sentTab:"Sent",
      receivedTab:"Received",
      viewMoreBttn:"View More",
      noEntries:"No entries to show",
      year:"Year",
      edit:"Edit",
      delete:"Delete",
      msgNotificationClose:"Cannot edit/submit this draft as the nomination window is closed.",
      alert:{
        alertContent:"Nomination Deleted Successfully!",
      },      
      dialog:{
        dlgTitle:"Delete Nomination",
        dlgContent:"Are you sure you want to delete this Nomination?",
        dlgYes:"Yes",
        dlgNo:"No"
      }

    },

    VIASection:{
      title:"Values in Action",
      subtitle:"Learn more about Values In Action from Chief Mission Officer Dougal Hewitt and other program founders.",
      compassion:'COMPASSION',
      dignity:'DIGNITY',
      justice:'JUSTICE',
      excellence:'EXCELLENCE',
      integrity:'INTEGRITY'
    },

    awardSection:{
      title:"System Awardees",
      imgText:"Click to play video"
    },

    nomDashboard:{
      title:"Your Nominations",
      sent: "Sent",
      received: "Received"
    },
    Faq:{
      title:"Questions",
      subtitle: "Browse our FAQ to quickly get answers about Values in Action and the nomination process. Still need help? ",
      link:" Contact our support team.",
      viewFaqBttn:"View FAQ",
      contact:`?subject=Values In Action support question&body=<Enter your question here>&cc=`
    },
    Submitted:{
      thankYou:"Thank you!",
      done:"Done",
    },

},

hi: {
  NominationPeriodClosure:{
    currentyear:"2022",
    nextyear:"2023",
    message: "2022 के लिए नामांकन अवधि बंद कर दी गई है। आप सभी असाधारण और समर्पित देखभाल करने वालों को पहचानने के लिए धन्यवाद और हम आपको 2023 में यहाँ वापस देखेंगे।"
  },

  VIANominations: {
    welcome: "आपका स्वागत है ",
    message:"वैल्यूज़ इन एक्शन अवार्ड प्रोविडेंस में दिया जाने वाला सर्वोच्च सम्मान है। यह वार्षिक मान्यता कार्यक्रम उन देखभाल करने वालों को मनाता है जो पांच मुख्य मूल्यों: करुणा, गरिमा, न्याय, उत्कृष्टता और अखंडता को मॉडल करने के लिए ऊपर और परे जाते हैं।",
     // "वैल्यूज़ इन एक्शन प्रोविडेंस सेंट जोसेफ हेल्थ के सभी लोगों को उन लोगों को मनाने की अनुमति देता है जो करुणा गरिमा न्याय उत्कृष्टता और अखंडता का प्रतीक हैं। हम उन लोगों का सम्मान करते हैं जो हमारे मिशन और बेहतर विश्व के लिए स्वास्थ्य के हमारे दृष्टिकोण के प्रति गहरी प्रतिबद्धता रखते हैं।",
    findAndNominate: "देखभाल करने वाले को ढूंढें और नामांकित करें",
    selectLabel: "कृपया अंतिम नाम दर्ज करें, पहला नाम",
    nominationsHeader:"नामांकन",
    valuesInActionHeader:"कार्रवाई में मूल्यों के बारे में",
    systemAwardeesHeader:"सिस्टम पुरस्कार विजेता",
    thoughtStartersPrompt: "पता नहीं कहाँ से शुरू करें? यहाँ कुछ",
    thoughtStartersLink: "विचार प्रारंभ",
  },

  searchBox:{
    selfNominationMsg:`आप खुद को नामांकित नहीं कर सकते। कृपया एक और चयन करें।`,
    duplicateNominationMsg:`आपने इस कर्मचारी के लिए इस वर्ष के लिए पहले ही नामांकन जमा कर दिया है। कृपया एक और चयन करें।`,
    error:`त्रुटि`,
    userNotFound: `कोई व्यक्ति नहीं मिला। यहां मैन्युअल रूप से नामांकन करने का प्रयास करें।`
  },

  errorMessage:{
    msg500: `बैकएंड में कुछ गलत हुआ`,
    msg400: `खराब अनुरोध`
  },

  nominationEditor:{
    intro: "अपना नामांकन लिखें",
    sampleWriteUp: "पता नहीं कहाँ से शुरू करें? यहां कुछ  ",
    writeUpLink: "विचार प्रारंभ करने के लिए",
    back:"वापस",
    textBoxPlaceHolder: "यहाँ लिखें...",
    of:"of",
    characters:"characters ",
    minimum:"(500 न्यूनतम)",
    submitAnonymously: "गुमनाम रूप से सबमिट करें",
    confirmationText: "क्या आप वाकई इस नामांकन को गुमनाम रूप से जमा करना चाहते हैं? वैल्यूज़ इन एक्शन नामांकन विस्तृत होना चाहिए और उन उपाख्यानात्मक उदाहरणों को उजागर करना चाहिए जिन्हें आपने नामांकित व्यक्ति के महान कार्य के बारे में अनुभव किया है। गुमनाम रूप से सबमिट करने से नामांकन में व्यक्तिगत अंतर्दृष्टि कम हो जाएगी। हालांकि नामांकित व्यक्ति आपकी जानकारी नहीं देख पाएगा, आपका नाम हमारी मिशन टीम के साथ साझा किया जाएगा जो आपके साथ अनुवर्ती कार्रवाई कर सकती है। ",
    yes:"हां",
    no:"नहीं",
    submit:"जमा",
    draft:"ड्राफ्ट के रूप में सेव करें"
  },

  nominationSection:{
    title:"नामांकन",
    draftTab:"प्रारूप",
    sentTab:"भेज दिया",
    receivedTab:"प्राप्त",
    viewMoreBttn:"और देखें",
    noEntries:"दिखाने के लिए कोई प्रविष्टि नहीं",
    year:"वर्ष",
    edit:"संपादित करें",
    delete:"हटाएं",
    msgNotificationClose:"Sइस मसौदे को संपादित/सबमिट नहीं कर सकता क्योंकि नामांकन विंडो बंद है।",
    alert:{
      alertContent:"नामांकन सफलतापूर्वक हटाया गया!",
    },      
    dialog:{
      dlgTitle:"नामांकन हटाएं",
      dlgContent:"क्या आप वाकई इस नामांकन को हटाना चाहते हैं?",
      dlgYes:"हां",
      dlgNo:"नहीं"
    }
  },

  VIASection:{
    title:"वैल्यूज़ इन एक्शन",
    subtitle:"मुख्य मिशन अधिकारी डगल हेविट और अन्य प्रोग्राम संस्थापकों से वैल्यू इन एक्शन के बारे में अधिक जानें।",
    compassion:'दया',
    dignity:'गौरव',
    justice:'न्याय',
    excellence:'उत्कृष्टता',
    integrity:'अखंडता'
  },

  awardSection:{
    title:"पुरस्कार विजेता",
    imgText:"वीडियो चलाने के लिए क्लिक करें"
  },

  nomDashboard:{
    title:"आपका नामांकन",
    sent: "भेज दिया",
    received: "प्राप्त"
  },


  Faq:{
    title:"प्रशन",
    subtitle: "वैल्यू इन एक्शन और नामांकन प्रक्रिया के बारे में तुरंत उत्तर पाने के लिए हमारे अक्सर पूछे जाने वाले प्रश्न ब्राउज़ करें। अभी भी सहायता चाहिए? ",
    link:" हमारी सहायता टीम से संपर्क करें।",
    viewFaqBttn:"अक्सर पूछे जाने वाले प्रश्न देखें",
    contact:`?subject=वैल्यू इन एक्शन सपोर्ट प्रश्न &body=<अपना प्रश्न यहां दर्ज करें>&cc=`
  },

  Submitted:{
    thankYou:"शुक्रिया!",
    done:"समाप्त",
  },

},

  du: { 
    NominationPeriodClosure:{
    currentyear:"2022",
    nextyear:"2023",
    message:"De nominatieperiode voor 2022 is gesloten. Bedankt voor het erkennen van alle buitengewone en toegewijde zorgverleners en we zien je hier terug in 2023."
  },

    VIANominations: {
      welcome: "Welkom ",
      message:"De Values ​​in Action Award is de hoogste onderscheiding die we bij Providence geven. Dit jaarlijkse erkenningsprogramma erkent verpleegkundigen die ernaar streven een voorbeeld te zijn van de vijf kernwaarden: mededogen, waardigheid, rechtvaardigheid, uitmuntendheid en integriteit.",
        //"Values in Action ermöglichen es allen Menschen in Providence St. Joseph Health, diejenigen zu feiern, die Mitgefühl, Würde, Gerechtigkeit, Exzellenz und Integrität verkörpern. Wir ehren diejenigen, die sich tief für unsere Mission und unsere Vision von Gesundheit für eine bessere Welt engagieren.",
      findAndNominate: "Selecteer de persoon om te nomineren",
      selectLabel: "Vul a.u.b. ACHTERNAAM, VOORNAAM in",
      nominationsHeader:"NOMINATIES",
      valuesInActionHeader:"OVER WAARDEN IN ACTIE",
      systemAwardeesHeader:"SYSTEEM AWARDEES",
      thoughtStartersPrompt: "Weet je niet waar je moet beginnen? Hier zijn enkele",
      thoughtStartersLink: "Gedachte Starters",
    },

    searchBox:{
      selfNominationMsg:`Je kunt jezelf niet nomineren. Maak een andere keuze.`,
      duplicateNominationMsg:`U heeft voor dit jaar al een voordracht voor deze medewerker ingediend. Maak een andere keuze.`,
      error:`fout`,
      userNotFound:"Geen gebruiker gevonden. Probeer hier handmatig te nomineren."
    },

    errorMessage:{
      msg500: `Achterin ging er iets mis`,
      msg400: `Foutief verzoek`
    },

    nominationEditor:{
      intro: "Schrijf je nominatie",
      sampleWriteUp: "Weet je niet waar je moet beginnen? Hier zijn een paar  ",
      writeUpLink: "gedachte starter",
      back:"RUG",
      textBoxPlaceHolder: "Schrijf hier...",
      of:"van",
      characters:"brieven",
      minimum:"(minstens 500)",
      submitAnonymously: "Anoniem indienen",
      confirmationText: "Weet u zeker dat u deze nominatie anoniem wilt indienen? Values ​​in Action-nominaties moeten gedetailleerd zijn en de echte voorbeelden benadrukken die je hebt gezien van het geweldige werk van de genomineerde. Anoniem indienen vermindert het persoonlijke inzicht in de nominatie.",
      yes:"EN",
      no:"NEE",
      submit:"INDIENEN",
      draft: "OPSLAAN ALS CONCEPT"
    },

    nominationSection:{
      title:"nominaties",
      draftTab:"ONTWERP",
      sentTab:"VERSTUURD",
      receivedTab:"ONTVANGEN",
      viewMoreBttn:"Bekijk meer",
      noEntries:"Geen inzendingen om te laten zien",
      year:"jaar",
      edit:"Bewerking",
      delete:"Verwijderen",
      msgNotificationClose:"Kan dit concept niet bewerken/inzenden omdat het nominatievenster is gesloten.",
      alert:{
        alertContent:"Nominatie succesvol verwijderd!",
      },      
      dialog:{
        dlgTitle:"Nominatie verwijderen",
        dlgContent:"Weet je zeker dat je deze Nominatie wilt verwijderen?",
        dlgYes:"Ja",
        dlgNo:"Nee"
      }
    },

    VIASection:{
      title:"Waarden in actie",
      subtitle:"Lees meer over Values ​​In Action van Chief Mission Officer Dougal Hewitt en andere oprichters van het programma.",
      compassion:'MEDELEVEN',
      dignity:'ZOU',
      justice:'GERECHTIGHEID',
      excellence:'UITMUNTENDHEID',
      integrity:'INTEGRITEIT'
    },

    awardSection:{
      title:"prijswinnaar",
      imgText:"Klik hier om de video af te spelen",
    },

    nomDashboard:{
      title:"prijswinnaar",
      sent: "VERSTUURD",
      received: "ONTVANGEN"
    },

 Faq:{
  title:"vragen",
  subtitle: "Zoek in onze FAQ voor snelle antwoorden over Values ​​in Action en het nominatieproces. Meer hulp nodig?",
  link:" Neem contact op met ons ondersteuningsteam.",
  viewFaqBttn:"BEKIJK VEELGESTELDE VRAGEN",
  contact:`?subject=Waarden in actie ondersteuningsvraag&body=<Vul hier uw vraag in>&cc=`
},
Submitted:{
  thankYou:"Heel erg bedankt!",
  done:"Afgerond",
}

},

sp:{
  NominationPeriodClosure:{
    currentyear:"2022",
    nextyear:"2023",
    message:"El período de nominación para 2022 se ha cerrado. Gracias por reconocer a todos los cuidadores extraordinarios y dedicados y nos vemos aquí en 2023"},

  VIANominations: {
    welcome: "¡Bienvenido ",
    message:"El Premio Valores en Acción es el honor más alto que otorgamos en Providence. Este programa de reconocimiento anual celebra a los cuidadores que van más allá para modelar los cinco valores fundamentales: Compasión, Dignidad, Justicia, Excelencia e Integridad.",
     // "Values in Action permite que todas las personas de Providence St. Joseph Health celebren a quienes encarnan la Compasión, la Dignidad, la Justicia, la Excelencia y la Integridad. Honramos a quienes se comprometen profundamente con nuestra Misión y nuestra visión de Salud para un mundo mejor.",
    findAndNominate: "Seleccione a alguien para nominar",
    selectLabel: "Por favor ingrese APELLIDO, NOMBRE",
    nominationsHeader:"NOMINACIONES",
    valuesInActionHeader:"SOBRE VALORES EN ACCIÓN",
    systemAwardeesHeader:"PREMIOS DEL SISTEMA",
    thoughtStartersPrompt: "¿No sabe por dónde empezar? Aquí hay algunas",
    thoughtStartersLink: "Iniciadores del pensamiento",
  },

  searchBox:{
    selfNominationMsg:`No puedes nominarte a ti mismo. Por favor haga otra selección.`,
    duplicateNominationMsg:`Ya presentó una nominación para este empleado para este año. Por favor haga otra selección.`,
    error:`Error`,
    userNotFound:`Usuario no encontrado. Intenta nominar manualmente aquí.`
  },

  errorMessage:{
    msg500: `Algo salió mal en la parte de atrás`,
    msg400: `Solicitud incorrecta`
  },

  nominationEditor:{
    intro: "Schreiben Sie Ihre Nominierung",
    sampleWriteUp: "¿No estás seguro por dónde empezar? Aquí hay algunas ",
    writeUpLink: "Iniciadores del pensamiento",
    back:"ESPALDA",
    textBoxPlaceHolder: "Escriba aqui...",
    of:"de",
    characters:"caracteres",
    minimum:"(500 mínimo)",
    submitAnonymously: "Enviar anónim",
    confirmationText: "¿Estás seguro de que deseas enviar esta nominación de forma anónima? Las nominaciones de Valores en Acción deben detallarse y resaltar ejemplos reales que haya experimentado del gran trabajo del nominado. Enviar anónimamente reducirá la percepción personal de la nominación.",
    yes:"SI",
    no:"NO",
    submit:"ENVIAR",
    draft:"GUARDAR COMO BORRADOR"
  },

  nominationSection:{
    title:"Nominaciones",
    draftTab:"SEQUÍA",
    sentTab:"EXPEDIDO",
    receivedTab:"RECIBIDO",
    viewMoreBttn:"Ver más",
    noEntries:"No hay entradas para mostrar",
    year:"Año",
    edit:"Editar",
    delete:"Eliminar",
    msgNotificationClose:"No se puede editar/enviar este borrador porque la ventana de nominación está cerrada.",
    alert:{
      alertContent:"¡Nominación eliminada con éxito!",
    },      
    dialog:{
      dlgTitle:"Eliminar nominación",
      dlgContent:"¿Estás segura de que quieres eliminar esta nominación?",
      dlgYes:"sí",
      dlgNo:"No"
    }
  },

  VIASection:{
    title:"Valores En Acción",
    subtitle:"Obtenga más información sobre Valores en acción del Director de Misión Dougal Hewitt y otros fundadores del programa.",
    compassion:'COMPASIÓN',
    dignity:'DIGNIDAD',
    justice:'JUSTICIA',
    excellence:'EXCELENCIA',
    integrity:'INTEGRIDAD'
  },

  awardSection:{
    title:"Ganadores Del Premio",
    imgText:"Haga clic para reproducir el video",
  },

  nomDashboard:{
    title:"Sus Nominaciones",
    sent: "EXPEDIDO",
    received: "RECIBIDO"
  },

  Faq:{
    title:"Preguntas",
    subtitle: "Explore nuestras preguntas frecuentes para obtener rápidamente respuestas sobre los valores en acción y el proceso de nominación ¿Aún necesitas ayuda?",
    link:" Póngase en contacto con nuestro equipo de soporte.",
    viewFaqBttn:"VER PREGUNTAS FRECUENTES",
    contact:`?subject=Pregunta de soporte de Valores en acción&body=<Introduzca su pregunta aquí>&cc=`
  },

  Submitted:{
    thankYou:"¡Gracias!",
    done:"Hecho",
  }
},

ph:{
  NominationPeriodClosure:{
    currentyear:"2022",
    nextyear:"2023",
    message:"Ang nominasyon panahon para sa 2022 ay sarado. Salamat sa pagkilala ninyo sa lahat ng pambihira at matatapat na tagapag-alaga at makikita namin kayo rito noong 2023."
  },
  VIANominations: {
    welcome: "Maligayang pagdating ",
    message:"Ang Values ​​in Action Award ay ang pinakamataas na karangalan na ibinibigay namin sa Providence. Ipinagdiriwang ng taunang programang ito sa pagkilala ang mga tagapag-alaga na lampas at higit pa upang imodelo ang limang pangunahing pagpapahalaga: Pagkahabag, Dignidad, Katarungan, Kahusayan at Integridad.",
      //"Ang mga pagpapahalaga sa Aksyon ay nagbibigay-daan sa lahat ng mga tao ng Providence St. Joseph Health upang ipagdiwang ang mga mayroong embodying Compassion, Dignity, Justice, Excellence at Integrity. Pinarangalan namin ang mga gumagawa ng malalim na mga pangako sa aming Misyon at ang aming pangitain sa Kalusugan para sa isang Mabuting Mundo.",
    findAndNominate: "Pumili ng isang tao upang mag-nominate",
    selectLabel: "Pakilagay ang APELYIDO, FIRST NAME",
    nominationsHeader:"MGA NOMINASYON",
    valuesInActionHeader:"TUNGKOL SA MGA HALAGA SA PAGKILOS",
    systemAwardeesHeader:"SYSTEM AWARDEES",
    thoughtStartersPrompt: "Hindi sigurado kung saan magsisimula? Narito ang ilang",
    thoughtStartersLink: "Mga Nagsisimula sa Pag-iisip",
  },

  searchBox:{
    selfNominationMsg:`Hindi mo maaaring italaga ang iyong sarili. Mangyaring gumawa ng isa pang pagpipilian.`,
    duplicateNominationMsg:`Nagsumite ka na ng isang nominasyon para sa empleyado para sa taong ito. Mangyaring gumawa ng isa pang pagpipilian.`,
    error:`Error`,
    userNotFound:`Walang nahanap na user. Subukang manu-manong magnomina dito.`
  },

  errorMessage:{
    msg500: `May naging mali sa likod`,
    msg400: `Masamang Kahilingan`
  },

  nominationEditor:{
    intro: "Isulat ang iyong hinirang",
    sampleWriteUp: "Hindi sigurado kung saan magsisimula? Narito ang ilang mga  ",
    writeUpLink: "Mga Nagsisimula sa Pag-iisip",
    back:"LIKOD",
    textBoxPlaceHolder: "Escriba aqui...",
    of:"ng",
    characters:"character",
    minimum:"(500 minimum)",
    submitAnonymously: "Isumite nang hindi nagpapakilala",
    confirmationText: "Sigurado ka bang nais mong isumite ang nominasyon na ito nang hindi nagpapakilala? Ang mga halaga sa mga nominasyon ng Pagkilos ay dapat na detalyado at i-highlight ang mga totoong halimbawa na naranasan mo sa mahusay na gawain ng nominee. Ang pagsusumite ng hindi nagpapakilala ay magbabawas ng personal na pananaw sa nominasyon.",
    yes:"OO",
    no:"HINDI",
    submit:"IPASA",
    draft:"I-SAVE BILANG DRAFT"
  },

  nominationSection:{
    title:"Mga Nominasyon",
    draftTab:"Draft",
    sentTab:"PUSO",
    receivedTab:"NAKAKITA",
    viewMoreBttn:"Tingnan ang Higit Pa",//View More
    noEntries:"Walang ipapakitang entry",
    year:"Taon",
    edit:"I-edit",
    delete:"tanggalin",
    msgNotificationClose:"Hindi maaaring i-edit/isumite ang draft na ito dahil sarado na ang window ng nominasyon.",
    alert:{
      alertContent:"Matagumpay na Natanggal ang Nominasyon!",
    },      
    dialog:{
      dlgTitle:"Tanggalin ang Nominasyon",
      dlgContent:"Sigurado ka bang gusto mong tanggalin ang Nominasyon na ito?",
      dlgYes:"Oo",
      dlgNo:"Hindi"
    }
  },

  VIASection:{
    title:"Mga Pagpapahalaga sa Aksyon",
    subtitle:"Dagdagan ang nalalaman tungkol sa Mga Pinahahalagahang Aksyon mula sa Punong Tagapangasiwa ng Misyon na si Dougal Hewitt at iba pang mga tagapagtatag ng programa.",
    compassion:'PAKIKIRAMAY',
    dignity:'DANGAL',
    justice:'HUSTISYA',
    excellence:'KAHUSAYAN',
    integrity:'INTEGRIDAD'
  },

  awardSection:{
    title:"Mga Awardee ng System",
    imgText:"Mag-click upang i-play ang video",
  },

  nomDashboard:{
    title:"Ang iyong mga Nominasyon",
    sent: "Puso",
    received: "Nakakita"
  },

  Faq:{
    title:"Mga Tanong",
    subtitle: "I-browse ang aming FAQ upang mabilis na makakuha ng mga sagot tungkol sa mga Halaga sa Aksyon at proseso ng nominasyon. Kailangan pa ba ng tulong? ",
    link:"  Makipag-ugnay sa aming koponan ng suporta.",
    viewFaqBttn:"TINGNAN ANG FAQ",
    contact:`?subject=Tanong ng suporta sa Values In Action&body=<Ipasok dito ang iyong katanungan>&cc=`,
  },

  Submitted:{
    thankYou:"Salamat!",
    done:"Tapos na",
  }

},

vt:{
  NominationPeriodClosure:{
    currentyear:"2022",
    nextyear:"2023",
    message:"Thời gian đề cử cho năm 2022 đã kết thúc. Cảm ơn bạn đã công nhận tất cả những người chăm sóc phi thường và tận tâm và chúng tôi sẽ gặp lại bạn ở đây vào năm 2023."
  },
  VIANominations: {
    welcome: "Chào mừng bạn ",
    message:"Giải thưởng Giá trị trong Hành động là vinh dự cao quý nhất mà chúng tôi trao tặng tại Providence. Chương trình công nhận hàng năm này tôn vinh những người chăm sóc vượt lên trên cả việc làm mẫu cho năm giá trị cốt lõi: Nhân ái, Nhân phẩm, Công bằng, Xuất sắc và Chính trực.",
      //"Các giá trị trong hành động cho phép tất cả mọi người của Providence St. Joseph Health tôn vinh những người đang thể hiện lòng trắc ẩn, nhân phẩm, công lý, xuất sắc và liêm chính. Chúng tôi tôn trọng những người cam kết sâu sắc với Sứ mệnh của chúng tôi và tầm nhìn của chúng tôi về Sức khỏe vì một Thế giới Tốt đẹp hơn.",
    findAndNominate: "Chọn ai đó để đề cử",
    selectLabel: "Vui lòng nhập TÊN CUỐI, TÊN",
    nominationsHeader:"THÔNG BÁO",
    valuesInActionHeader:"GIỚI THIỆU GIÁ TRỊ TRONG HÀNH ĐỘNG",
    systemAwardeesHeader:"GIẢI THƯỞNG HỆ THỐNG",
    thoughtStartersPrompt: "Không chắc bắt đầu từ đâu? Dưới đây là một số",
    thoughtStartersLink: "Gợi ý viết",
  },

  
  searchBox:{
    selfNominationMsg:`Bạn không thể đề cử chính mình. Vui lòng lựa chọn khác.`,
    duplicateNominationMsg:`Bạn đã gửi một đề cử cho nhân viên này trong năm nay. Vui lòng lựa chọn khác.`,
    error:`Lỗi`,
    userNotFound:`Không tìm thấy người dùng. Hãy thử đề cử theo cách thủ công tại đây.`
  },

  errorMessage:{
    msg500: `Đã xảy ra sự cố ở phía sau`,
    msg400: `Yêu cầu không hợp lệ`
  },

  nominationEditor:{
    intro: "Viết đề cử của bạn",
    sampleWriteUp: "Không biết chắc nên bắt đầu từ đâu? Dưới đây là một số  ",
    writeUpLink: "Người khởi động suy nghĩ",
    back:"TRỞ LẠI",
    textBoxPlaceHolder: "Escriba aqui...",
    of:"trong số ",
    characters:"ký tự",
    minimum:"(tối thiểu 500)",
    submitAnonymously: "Gửi nặc danh",
    confirmationText: "Bạn có chắc chắn muốn gửi đề cử này nặc danh? Các giá trị trong các đề cử Hành động phải được chi tiết và nêu bật các ví dụ thực tế mà bạn đã trải nghiệm về công việc tuyệt vời của người được đề cử. Gửi ẩn danh sẽ làm giảm cái nhìn sâu sắc cá nhân trong đề cử.",
    yes:"ĐÚNG",
    no:"KHÔNG",
    submit:"GỬI ĐI",
    draft:"LƯU DƯỚI DẠNG BẢN NHÁP"
  },

  nominationSection:{
    title:"Đề cử của bạn",
    draftTab:"Bản nháp",
    sentTab:"GỞI",
    receivedTab:"NHẬN",
    viewMoreBttn:"Xem thêm",
    noEntries:"Không có mục nào để hiển thị",
    year:"Năm",    
    edit:"Biên tập",
    delete:"xóa bỏ",
    msgNotificationClose:"Không thể chỉnh sửa / gửi bản nháp này vì cửa sổ đề cử đã đóng.",
    alert:{
      alertContent:"Đề cử đã được xóa thành công!",
    },      
    dialog:{
      dlgTitle:"Xóa đề cử",
      dlgContent:"Bạn có chắc chắn muốn xóa Đề cử này không?",
      dlgYes:"Vâng",
      dlgNo:"Không"
    }
  },

  VIASection:{
    title:"Giá trị trong hành động",
    subtitle:"Tìm hiểu thêm về Giá trị trong Hành động từ Giám đốc Truyền giáo Dougal Hewitt và những người sáng lập chương trình khác.",
    compassion:'THƯƠNG HẠI',
    dignity:'NHÂN PHẨM',
    justice:'SỰ CÔNG BẰNG',
    excellence:'XUẤT SẮC',
    integrity:'CHÍNH TRỰC'
  },

  awardSection:{
    title:"Giải Cho Người Chiến Thắng",
    imgText:"Bấm để phát video",
  },

  nomDashboard:{
    title:"Đề cử của bạn",
    sent: "Gởi",
    received: "Nhận"
  },

  Faq:{
    title:"Câu hỏi",
    subtitle: "Duyệt Câu hỏi thường gặp của chúng tôi để nhanh chóng nhận được câu trả lời về Giá trị trong Hành động và quy trình đề cử. Vẫn cần trợ giúp? ",
    link:" Liên hệ với nhóm hỗ trợ của chúng tôi.",
    viewFaqBttn:"XEM FAQ",
    contact:`?subject=Câu hỏi hỗ trợ về Giá trị trong Hành động&body=<Nhập câu hỏi của bạn tại đây>&cc=`
  },
  
	Submitted:{
    thankYou:"Cảm ơn bạn!",
    done:"Làm xong",
  }

},

ch:{
  NominationPeriodClosure:{
    currentyear:"2022",
    nextyear:"2023",
    message:"2022年的提名期已經結束。感謝您認可所有非凡而敬業的護理人員，我們將在2023年與您見面。",
  },

  VIANominations: {
    welcome: "欢迎 ",
    message:"行动价值观奖是我们在普罗维登斯授予的最高荣誉。这项年度表彰计划旨在表彰超越并超越五个核心价值观的护理人员：同情心、尊严、正义、卓越和正直。",
      //"行动价值观使普罗维登斯圣约瑟夫健康的所有人能够庆祝那些体现慈悲、尊严、正义、卓越和正直的人。我们尊重那些对我们的使命和我们健康更美好世界愿景作出深刻承诺的人。",
    findAndNominate: "选择某人提名",
    selectLabel: "请输入姓氏、名字",
    nominationsHeader:"提名",
    valuesInActionHeader:"关于行动中的价值观",
    systemAwardeesHeader:"系统获奖者",
    thoughtStartersPrompt: "不知道从哪里开始？以下是一些",
    thoughtStartersLink: "思路提示",
  },

  searchBox:{
    selfNominationMsg:`您不能提名自己。 请进行其他选择。`,
    duplicateNominationMsg:`您已经提交了该员工今年的提名。 请进行其他选择。`,
    error:`错误`,
    userNotFound:`未找到用户。尝试在此处手动提名。`
  },

  errorMessage:{
    msg500: `后面出了点问题`,
    msg400: `错误的请求`
  },

  nominationEditor:{
    intro: "写您的提名",
    sampleWriteUp: "不知道从哪里开始？这里有一些 ",
    writeUpLink: "思想初学者",
    back:"背部",
    textBoxPlaceHolder: "写在这里...",
    of:"个",
    characters:"个字符",
    minimum:"(最少500个字符)",
    submitAnonymously: "匿名提交",
    confirmationText: "您确定要匿名提交此提名吗？ 行动价值观的提名应该详尽，并突出您所经历的关于提名者出色工作的真实例子。 匿名提交将减少提名中的个人见解",
    yes:"是的",
    no:"没有",
    submit:"提交",
    draft:"保存为草稿"
  },

  nominationSection:{
    title:"您的提名",
    draftTab:"草案",
    sentTab:"已发送",
    receivedTab:"已收到",
    viewMoreBttn:"查看更多",
    noEntries:"没有可显示的条目",
    year:"年",
    edit:"编辑",
    delete:"删除",
    msgNotificationClose:"由于提名窗口关闭, 无法编辑/提交此草稿",
    alert:{
      alertContent:"已成功删除提名!",
    },      
    dialog:{
      dlgTitle:"删除提名",
      dlgContent:"您确定要删除此提名吗?",
      dlgYes:"是的",
      dlgNo:"不"
    }
  },

  VIASection:{
    title:"行动中的价值观",
    subtitle:"向首席宣教士Dougal Hewitt和其他计划创始人了解有关行动中价值观的更多信息。",
    compassion:'同情',
    dignity:'尊严',
    justice:'正义',
    excellence:'卓越',
    integrity:'正直'
  },

  awardSection:{
    title:"A获奖者",
    imgText:"点击播放视频",
  },

  nomDashboard:{
    title:"您的提名",
    sent: "已发送",
    received: "已收到"
  },

Faq:{
  title:"问题",
  subtitle: "浏览我们的常见问题解答，以快速获取有关“行动中的价值观”和提名流程的答案。 还需要帮助吗？ ",
  link:" 联系我们的支持团队 。",
  viewFaqBttn:"查看常见问题",
  contact:`?subject=价值观在行动支持问题&body=<在此处输入您的问题>&cc=`
},

Submitted:{
  thankYou:"谢谢！",
  done:"完成了",
}


}



};
